import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/computrain.webp';
import screenshot_target from '../../../images/letterfunnel/martijnsteffers.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Martijn Steffers"
      firstname="Martijn"
      companyname="Computrain"
      competition="Global Knowledge en Vijfhart IT-opleidingen"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/martijnsteffers.js